<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar
          v-model="formData"
          @search="handleSearch"
          @Reset="Reset"
          @tagClose="tagClose"
          @switchChange="switchChange"
          @code="code"
          ref="search"
        ></search-bar>
      </el-header>
    </el-container>
    <div class="main">
      <div class="left">
        <div class="search-boxH">
          <search-buttom ref="searchButtom" @keyupEnter="keyupEnter"></search-buttom>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <strong>相关产品排名Top10</strong>
        </div>
        <el-divider></el-divider>
        <div class="canvas-box" v-loading="loading">
          <div class="no-data" v-show="!echatsData.length">暂无数据</div>
          <div
            ref="overview"
            class="canvas-left"
            v-show="echatsData.length"
          ></div>
          <div class="canvas-right" v-show="echatsData.length">
            <el-table
              :data="echatsData"
              :header-cell-style="{
                backgroundColor: '#FAFAFA',
              }"
              :row-style="{ height: '2.12vw' }"
              :cell-style="rowClass"
              height="calc(100% - 10px)"
              style="width: calc(100% - 20px)"
            >
              <el-table-column
                prop="bigModel"
                max-width="80px"
                align="center"
                label="所属型号"
              >
                <template slot-scope="scope">
                  <el-link
                    :underline="false"
                    class="border-bottom"
                    @click="modelQuery(scope.row.bigModel)"
                    >{{ scope.row.bigModel }}</el-link
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="nowStoreSaleNum"
                max-width="80px"
                align="center"
                label="当前店铺"
              ></el-table-column>
              <el-table-column
                prop="allStoreSaleNum"
                max-width="60px"
                align="center"
                label="全网"
              >
              </el-table-column>
              <el-table-column
                prop="type"
                max-width="60px"
                align="center"
                label="属性"
              >
                <template slot-scope="scope">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="showDialog(scope.row, 0)"
                    >查看</el-link
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <el-divider></el-divider>
        <div class="right-footer">
          <div class="title">
            <strong>主推类型总览</strong>
          </div>
          <div style="padding-left: 25px; height: 100%">
            <el-table
              border
              :data="modelData"
              height="calc(100% - 20px)"
              style="width: calc(100% - 30px)"
              v-loading="loading1"
            >
              <el-table-column v-for="item  in modelColumn" :key="item.prop" :prop="item.prop" align="center" :label="item.lable">
                <template slot-scope="scope">
                  <el-link
                    :underline="false"
                    @click="showOverviewDialog(scope.row[scope.column.property],item.lable)"
                    >{{ scope.row[item.prop] }}</el-link
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 查看弹框 -->
    <property-view
      v-model="recordDialogVisible"
      @dialog="dialog"
      :dialogData="dialogData"
      v-if="recordDialogVisible"
    ></property-view>
    <overview-dialog
      v-model="overviewDialogVisible"
      @overviewDialog="overviewDialog"
      :overviewData="overviewData"
      v-if="overviewDialogVisible"
    ></overview-dialog>
  </div>
</template>

<script>
  import searchBar from "./search.vue";
  import searchButtom from "./common/buttom.vue";
  import ranking from "./ranking.js";
  import propertyView from "./common/propertyView.vue";
  import overviewDialog from "./common/overviewDialog.vue";
  import pagePathMixin from '@/utils/page-path-mixin'

  export default {
  name: "ComprehensiveQuery",
  mixins: [ranking, pagePathMixin],
  components: {
    searchBar,
    searchButtom,
    propertyView,
    overviewDialog
  },
  data() {
    return {
      tableHeight: 0,
      loading1: false,
      loading: false,
      formData: {},
      recordDialogVisible: false,
      overviewDialogVisible: false,
      form: {},
      dialogData: [],
      overviewData: [],
      queryContent: {},
      echatsData: [],
      modelData: [],
      modelColumn: []
    };
  },
  computed: {
    columnData() {
      let data = [
        {prop:'bed',lable:'床'},
        {prop:'sofa',lable:'沙发'},
        {prop:'wardrobe',lable:'衣柜'},
        {prop:'diningTable',lable:'餐桌'},
        {prop:'teaElectricityComb',lable:'茶电组合'},
        {prop:'leisure',lable:'休闲'},
        {prop:'other',lable:'其他'},
      ]
      return data
    },
    resolvingPower() {
      return document.body.clientWidth
    },
  },
  mounted() {
    // this.init();
    // this.getMainModel();
  },
  methods: {
    handleSearch(data) {
      this.formData = { ...data, ...this.$refs["searchButtom"].form };
      if(!this.formData.storeCode) {
        this.$message.error("店铺信息未选择，请填写后再搜索")
        return
      }else if(!this.formData.categoryName) {
        this.$message.error("类别信息未填写，请填写后再搜索")
        return
      }else if((!this.formData.lengthUpper && this.formData.lengthLower) || (this.formData.lengthUpper && !this.formData.lengthLower)) {
        this.$message.error("长度起始值未填写完整，请填写后再搜索")
        return
      }else if((!this.formData.widthUpper && this.formData.widthLower) || (this.formData.widthUpper && !this.formData.widthLower)) {
        this.$message.error("宽度起始值未填写完整，请填写后再搜索")
        return
      }else if((!this.formData.heightUpper && this.formData.heightLower) || (this.formData.heightUpper && !this.formData.heightLower)) {
        this.$message.error("高度起始值未填写完整，请填写后再搜索")
        return
      }
      this.init();
      let queryContent = this.$refs["searchButtom"].queryContent;
      this.$refs["search"].queryContent = queryContent;
    },
    code(data) {
      this.loading1 = true;
      this.modelColumn = []
      let params = {
        params:{
          storeCode: data || ""
        }
      }
      this.$q.intelligentRecom
        .getMainModels(params)
        .then((res) => {
          if (res.data && res.code == 200) {
            let data = res.data.keyAndVal
            Object.keys(data).forEach(key=>{
              this.modelColumn.push({
                lable: data[key],
                prop: [key][0]
              })
            })
            this.modelData = res.data.dataList;
          } else {
            this.modelData = [];
          }
        })
        .finally((_) => {
          this.loading1 = false;
        });
    },
    keyupEnter(data) {
      this.formData = { storeCode:this.formData.storeCode, ...data };
      this.init();
      let queryContent = this.$refs["searchButtom"].queryContent;
      this.$refs["search"].queryContent = queryContent;
    },
    tagClose(data) {
      this.$refs["searchButtom"].TagCloseInput(data);
    },
    switchChange(data) {
      this.$refs['searchButtom'].dataRange = data
    },
    Reset() {
      this.echatsData =  []
      this.$refs["searchButtom"].TagCloseInput([])
      this.$refs["searchButtom"].colorIndex = {
        categoryName: "",
        saleAmountEnd: "",
        style: "",
        productSize: "",
        color: "",
        functionality: "",
        material: "",
        payTime: 2,
      }
      this.$refs["searchButtom"].getOptionsn()
    },
    init() {
      this.loading = true;
      console.log(999);
      this.$q.intelligentRecom
        .saleNumTopTen({ data: this.formData })
        .then((res) => {
          if (res.data.length && res.code == 200) {
            this.$nextTick((_) => {
              this.echatsData = res.data;
              this.$nextTick((_) => {
              this.render_left(this.echatsData,this.resolvingPower);
            });
            });
          } else {
            this.echatsData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    //主推型号总览
    // getMainModel() {
    //   let params = {
    //     params:{
    //       storeCode: this.formData.storeCode || ""
    //     }
    //   }
    //   this.$q.intelligentRecom
    //     .getMainModels(params)
    //     .then((res) => {
    //       if (res.data.dataList.length && res.code == 200) {
    //         let data = res.data.keyAndVal
    //         Object.keys(data).forEach(key=>{
    //           this.modelColumn.push({
    //             lable: data[key],
    //             prop: [key][0]
    //           })
    //         })
    //         this.modelData = res.data.dataList;
    //       } else {
    //         this.modelData = [];
    //       }
    //     })
    //     .finally((_) => {
    //       this.loading = false;
    //     });
    // },

    showOverviewDialog(bigModel,lable) {
      let data = {
        bigModel: bigModel,
        categoryName: lable,
        storeCode: this.$refs["search"].form.storeCode

      }
      this.$q.intelligentRecom
        .bigModelBaseData({data:data})
        .then((res) => {
          if (res.data && res.code == 200) {
            console.log(res.data);
            this.overviewData = res.data;
            this.overviewDialogVisible = true;
          } else {
            // this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    showDialog(row) {
      let data = {
        productCode: row.productCode,
        payTimeStart: this.formData.payTimeStart,
        payTimeEnd: this.formData.payTimeEnd,
        storeCode: this.formData.storeCode
      }
      this.see(data);
    },

    //产品基础属性查看 搜索
    see(data) {
      this.$q.intelligentRecom
        .baseData({data:data})
        .then((res) => {
          if (res.data && res.code == 200) {
            this.dialogData = res.data;
            this.recordDialogVisible = true;
            console.log(this.dialogData);
          } else {
            // this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    modelQuery(bigModel) {
      this.openSubPage({
        path: "/modelQuery",
        query: {
          // fileType: Global.FILE_TYPE['包件在产状态'],
          bigModel: bigModel,
          categoryName: this.formData.categoryName,
          payTimeStart: this.formData.payTimeStart || "",
          payTimeEnd: this.formData.payTimeEnd || "",
          color: this.formData.color || "",
        },
      });
    },

    dialog(type) {
      this.recordDialogVisible = type;
    },
    overviewDialog(type) {
      this.overviewDialogVisible = type;
    },
    rowClass(data) {
      if (data.column.label == "当前店铺") {
        return "color: #4BBFE2;";
      } else if (data.column.label == "全网") {
        return "color: #FF8A02;";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 10px);
  box-sizing: border-box;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.main {
  height: calc(100% - 55px);
  display: flex;
  flex-wrap: nowrap;
  border-radius: 5px;
}

.left {
  width: calc(50% - 5px);
  background: #ffffff;
  border-radius: 5px;
}

.right {
  height: 100%;
  margin-left: 5px;
  width: calc(50%);
  background: #ffffff;
  border-radius: 5px;
}

.title {
  font-size: 16px;
  color: #444;
  padding: 10px 25px 10px 25px;
}

.search-boxH {
  padding: 20px 10px;
  height: calc(100% - 45px);
  overflow-y: auto;
}

.canvas-box {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  height: calc(60% - 30px);
}

.right-footer {
  height: calc(40% - 45px);
}

// .canvas-box div {
// flex: 1;
// padding-top: 10px;
// }
.canvas-left {
  width: 55%;
  padding-top: 10px;
}

.canvas-right {
  width: 45%;
  padding-top: 10px;
}

>>> .canvas-box .el-table th {
  background: #fff !important;
  color: #000;
}

.title-footer {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-buttom: 10px;
  // width: 100%
  background-color: rgb(244, 244, 244);
}

.title-footer div {
  dislpay: block;
  height: 25px;
  width: 100px;
  line-height: 25px;
  background-color: #24c69a;
  border-radius: 5px;
  text-align: center;
}

>>> .el-divider--horizontal {
  margin: 0 0;
}

>>> ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.canvas-box /deep/.el-table {
  border: 0;

  th, tr, td {
    border: 0;
    background-color: #fff;
  }

  &::before {
    height: 0px;
  }

  &::after {
    width: 0;
  }

  .el-table__fixed:before {
    height: 0;
  }
}

.no-data {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  padding: 40px 0;
}


>>> .border-bottom  {
  border-bottom: 1px solid #0BB78E
}
</style>
